import React, { useEffect, useState } from "react";
import { Form, FormikProvider, useFormik } from "formik";
import {
  Autocomplete,
  Box,
  Button,
  Chip,
  Stack,
  TextField,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { useSelector } from "react-redux";
import {
  changeBatchStatus,
  getBatchesList,
  getCardsData,
  getTutorsList,
  updateRestartDate,
} from "../../redux/features/batchSlice";
import { Icon } from "@iconify/react/dist/iconify.js";
import GlobalDialog from "../../components/mui/Dialogue/GlobalDialog";
import GlobalSelectField from "../../components/mui/GlobalSelectField";
import * as Yup from "yup";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const BatchStatus = ({ rowData, dispatchData, open, edit, setOpen }) => {
  // const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading } = useSelector((state) => state.batch);

  const BatchStatuses = [{ id: 2, name: "Temporary Inactive" }];

  const validationSchema = Yup.object().shape({
    type: Yup.string().required("Choose status"),
    // batch_inactive_reason: Yup.string().required("Reason is required"),
    batch_restart_date: Yup.string()
      .nullable()
      .required("Restart date is required"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      type: 2,
      batchID: rowData?.course_batch_id || edit?.course_batch_id,
      batch_inactive_reason: "",
      batch_restart_date: null,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      if (edit) {
        dispatch(updateRestartDate(values)).then((res) => {
          if (res.payload.status === "success") {
            enqueueSnackbar(res.payload.message, {
              variant: "success",
            });
            dispatch(getCardsData());
            dispatch(getBatchesList(dispatchData));
            setOpen(false);
          } else {
            enqueueSnackbar(res.payload.message, {
              variant: "error",
            });
          }
        });
      } else {
        dispatch(changeBatchStatus(values)).then((res) => {
          if (res.payload.status === "success") {
            enqueueSnackbar(res.payload.message, {
              variant: "success",
            });
            dispatch(getCardsData());
            dispatch(getBatchesList(dispatchData));
            setOpen(false);
          } else {
            enqueueSnackbar(res.payload.message, {
              variant: "error",
            });
            // setOpen(false);
          }
        });
      }
    },
  });

  return (
    <GlobalDialog
      title={"Temporary Inactive"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"xs"}
      closeButton={true}
      // popupButton={
      //   <Button
      //     size="small"
      //     variant="outlined"
      //     color="primary"
      //     onClick={() => setOpen(true)}
      //   >
      //     <Icon
      //       icon={"material-symbols-light:change-circle-outline"}
      //       width={18}
      //       height={18}
      //     />
      //     Change Status
      //   </Button>
      // }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack direction={"column"} spacing={2}>
                  <GlobalSelectField
                    options={{
                      formik,
                      name: "type",
                      label: "Status",
                      data: BatchStatuses,
                      keys: {
                        id: "id",
                        value: "name",
                      },
                    }}
                  />
                  {edit && (
                    <Chip
                      label={`Restart Date: ${edit?.batch_restart_date}`}
                      variant="filled"
                      color="secondary"
                    />
                  )}
                  <Stack direction={"column"} spacing={2}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label={edit ? "New Restart Date" : "Restart Date"}
                        value={formik.values.batch_restart_date}
                        onChange={(newValue) => {
                          const selectedDate = dayjs(newValue);
                          formik.setFieldValue(
                            "batch_restart_date",
                            selectedDate.format("YYYY-MM-DD")
                          );
                        }}
                        format="YYYY-MM-DD"
                        minDate={dayjs()}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            error:
                              formik.touched.batch_restart_date &&
                              Boolean(formik.errors.batch_restart_date),
                            helperText:
                              formik.touched.batch_restart_date &&
                              formik.errors.batch_restart_date,
                            onKeyDown: (e) => e.preventDefault(),
                          },
                        }}
                      />
                    </LocalizationProvider>
                    {!edit && (
                      <TextField
                        name="batch_inactive_reason"
                        label="Reason for Inactivity"
                        value={formik.values.batch_inactive_reason}
                        onChange={formik.handleChange}
                        error={
                          formik.touched.batch_inactive_reason &&
                          Boolean(formik.errors.batch_inactive_reason)
                        }
                        helperText={
                          formik.touched.batch_inactive_reason &&
                          formik.errors.batch_inactive_reason
                        }
                        placeholder="Enter reason for inactivity"
                        fullWidth
                      />
                    )}
                  </Stack>
                </Stack>
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}
                >
                  <Stack direction={"row"} spacing={1}>
                    <Button
                      size="small"
                      variant="outlined"
                      color="secondary"
                      onClick={() => setOpen(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      disabled={loading}
                      variant="contained"
                      color="secondary"
                      size="small"
                      type="submit"
                    >
                      {loading ? "Please wait..." : "Save"}
                    </Button>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default BatchStatus;
